import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../../../common/Classes';

const ExhibitorInfo = (props) => {
  const {
    content, label, id, detailPageLink, tag, triggerMixpanelEvent, element, showHeading, testId
  } = props;

  const contentExist = content && content.length > 0;

  if (!contentExist) return null;

  return (
    <div data-testid={testId}
        className={classnames(Classes.exhibitorInfo)}>
        {showHeading && <h4 className={Classes.textLeft}>{label}</h4>}
      <a
        href={detailPageLink}
        data-dtm={tag}
        data-dtm-attributes={JSON.stringify({ exhibitorId: id })}
      >
        <p className={classnames(Classes.wrapWord, Classes.multilineEllispes)}
           data-testId='exh-content'
           onClick={() => triggerMixpanelEvent(element)}>
          {content}
        </p>
      </a>
    </div>
  );
};

ExhibitorInfo.propTypes = {
  detailPageLink: PropTypes.string.isRequired,
    showHeading: PropTypes.bool,
  label: PropTypes.string,
  content: PropTypes.string,
  tag: PropTypes.string,
  id: PropTypes.string.isRequired,
  triggerMixpanelEvent: PropTypes.func,
  element: PropTypes.string,
  testId: PropTypes.string,
};

export default ExhibitorInfo;
